<!-- map-view.component.html -->
<div class="map-container">
  <div id="map" [ngStyle]="{ 'height': mapHeight }" style="width: 100%; border-radius: 8px; border: 1px solid #ddd;"></div>
</div>
